import { PatientAddConsultationPage } from "$routes/dev-patient/[:patientId]/add-consultation/page";
import { PatientDispensePrescriptionsPage } from "$routes/dev-patient/[:patientId]/dispense-prescriptions/page";
import { PatientHistoryPage } from "$routes/dev-patient/[:patientId]/overview/history/page";
import { PatientInsurancePage } from "$routes/dev-patient/[:patientId]/overview/insurance/page";
import { PatientOverviewLayout } from "$routes/dev-patient/[:patientId]/overview/layout";
import { ClinicalDecisionSupportProvider } from "$routes/patient/[:patientId]/_lib/clinical-decision-support-service/provider";
import { InvestigationActivitiesProvider } from "$routes/patient/[:patientId]/_lib/investigations/investigation-activities-provider";
import { VaccinationsProvider } from "$routes/patient/[:patientId]/_lib/vaccinations-service/provider";
import { NewInvestigationPage } from "$routes/patient/[:patientId]/investigations/new/page";
import { Outlet, Route, Routes, useParams } from "react-router-dom";

const Providers = () => {
  const { patientId } = useParams();

  return (
    <ClinicalDecisionSupportProvider patientId={patientId}>
      <VaccinationsProvider patientId={patientId}>
        <InvestigationActivitiesProvider patientId={patientId}>
          <Outlet />
        </InvestigationActivitiesProvider>
      </VaccinationsProvider>
    </ClinicalDecisionSupportProvider>
  );
};

export const DevPatientRoutes = () => {
  return (
    <Routes>
      <Route path=":patientId" element={<Providers />}>
        <Route
          path="add-consultation"
          element={<PatientAddConsultationPage />}
        />
        <Route path="add-investigations" element={<NewInvestigationPage />} />
        <Route
          path="dispense-prescriptions"
          element={<PatientDispensePrescriptionsPage />}
        />
        <Route path="overview" element={<PatientOverviewLayout />}>
          <Route path="history" element={<PatientHistoryPage />} />
          <Route path="insurance" element={<PatientInsurancePage />} />
        </Route>
      </Route>
    </Routes>
  );
};
